import { loadPages, IPagesPayload } from "../redux/actions/app";
import BasePoller, { PollIntervalConfig } from "./BasePoller";

const INTERVAL_CONFIG: PollIntervalConfig = [{ milliseconds: 1000, count: 10 }];

class SitePagesPoller extends BasePoller<IPagesPayload, void> {
	public store; // redux store reference
	private _pagesPayload: IPagesPayload = null;

	public get pagesPayload(): IPagesPayload {
		return this._pagesPayload;
	}

	getPollIntervalConfig(): PollIntervalConfig {
		return INTERVAL_CONFIG;
	}

	getData(): Promise<IPagesPayload> {
		console.debug("SitePagesPoller getData");
		return this.store.dispatch(loadPages());
	}

	keepPolling(payload: IPagesPayload): boolean {
		console.debug("SitePagesPoller.keepPolling() payload:", payload);
		if (!payload || !payload.pages || !payload.pages.length) return true;
		this._pagesPayload = payload;
		console.debug("SitePagesPoller.keepPolling(): Pages loaded. No need to poll.");
		return false;
	}
}

const Singleton = (() => {
	let _sitePagesPoller: SitePagesPoller;

	return {
		getInstance: (): SitePagesPoller => {
			if (!_sitePagesPoller) {
				_sitePagesPoller = new SitePagesPoller();
			}
			return _sitePagesPoller;
		},
	};
})();

export default Singleton.getInstance();
